import React from "react";
import Field from "../../../model/configurator/Field";
import BaseInputValidator from "../input-validators/BaseInputValidator";


export interface BaseFieldSelfProps {
    value: any,
    readonly: boolean,
    disabled: boolean,
    text: string,
    field: Field,
    validator: BaseInputValidator | null,
    onChange: any,
    errorState: boolean,
    errorMessage: string,
    unitLabel: string | number,
    description?: string,
    label?: string,
    className?: string,
    noLabel?: boolean
    required?: boolean
}

export interface BaseFieldSelfState {
    value: any,
    errorState: boolean,
    errorMessage: string
}

export default class BaseField<TProps, TState> extends React.Component<BaseFieldSelfProps & TProps, BaseFieldSelfState & TState> {
    isValid = (): boolean => !this.state.errorState;

    updateStoreValue(newValue: any) {
        if (this.props.field) {
            this.props.field.setValue(newValue)
        }
    }

    renderLabel = (): boolean => {
        return this.props.noLabel === undefined || !this.props.noLabel;
    }

    getLabel = (): string => {
        return `${this.props.label} ${this.props.required ? '*' : ''}`;
    }

    render() {
        return (
            <React.Fragment>
                {this.renderField()}
            </React.Fragment>
        )
    }

    renderField(): React.ReactNode {
        throw new Error('NotImplementedError: Field#renderField')
    }

    /**
     * Generates a number that can be used to uniquely identify fields or inputs.
     * @return {String}
     */
    generateUniqueId() {
        return String(Math.floor(Math.random() * (Number.MAX_SAFE_INTEGER) / 100))
    }

    renderDescription = () => {
        if (!this.props.description || this.props.description.length === 0) {
            return <React.Fragment></React.Fragment>
        }
        return <div className={`description`}>{this.props.description}</div>
    }
    renderErrorMessage = () => {
        if (!this.state.errorState || this.state.errorMessage.length === 0) {
            return <React.Fragment></React.Fragment>
        }
        return <div className={`error-message`}>{this.state.errorMessage}</div>
    }

    getClassNames = () => {
        let classNames = 'step-input-field-container'
        if (this.props.className) {
            classNames += ' ' + this.props.className
        }
        if (this.props.readonly) {
            classNames += ' ' + '--readonly'
        }
        if (this.state.errorState) {
            classNames += ' ' + 'error'
        }
        return classNames;
    }
}